module.exports = __webpack_public_path__ + "img/hc_pro_two_5.bf75a02f.jpg";